import { createRoot } from 'react-dom/client';
import App from './app/App.tsx';
import './styles/index.css';
import { initMonitoring } from './app/utils/monitoring';

// Initialise error monitoring before rendering.
// Activates automatically when VITE_SENTRY_DSN is set in environment.
initMonitoring();

createRoot(document.getElementById('root')!).render(<App />);
